import React, {useState} from "react"
import { spartans } from "../../../../data/spartans"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const Spartans = (props) => {

    const selectList = spartans.map(spartan => ({
        id:spartan.id,
        name:spartan.name,
        wood:spartan.wood,
        clay:spartan.clay,
        iron:spartan.iron,
        crop:spartan.crop,
        all: spartan.wood + spartan.clay + spartan.crop + spartan.iron
    }) )

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function vypis() {
        const selectedSpartan = selectList[selectValue-1]
        props.addItem(selectedSpartan)
    }

return (
    <div>
        <ListSelect label="...choose trop..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    )
}
export default Spartans